<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-bh-user-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-bh-user-form" @submit.prevent="onSubmit">
        <div class="new-bh-user-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-bh-user-toolbar-title"
              >Add User</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title class="new-bh-user-card-title">User data</v-card-title>
          <v-container class="new-bh-user-card-container">
            <v-row>
              <v-col class="new-bh-user-form-col-left" sm="6">
                <dialog-input
                  label="First name"
                  name="firstName"
                  @input="onInput"
                />
              </v-col>
              <v-col class="new-bh-user-form-col-right" sm="6">
                <dialog-input
                  label="Last name"
                  name="lastName"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-bh-user-card-container">
            <v-row>
              <v-col class="new-bh-user-form-col-left" sm="6">
                <dialog-select
                  label="Role"
                  name="roleId"
                  :items="roleIdOptions"
                  @input="onInput"
                />
              </v-col>
              <v-col class="new-bh-user-form-col-right" sm="6">
                <dialog-input label="PhoneNo" name="phone" @input="onInput" />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-bh-user-card-container pb-0">
            <v-row>
              <v-col class="new-bh-user-form-col-left" sm="6">
                <dialog-input
                  v-if="newUserData.roleId == 2"
                  label="Capacity"
                  name="capacity"
                  :use-numbers="true"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-bh-user-card-container">
            <dialog-input
              label="Email address"
              name="email"
              @input="onInput"
              :validate="true"
              :validationType="'email'"
            />
          </v-container>
        </div>
        <v-container class="new-bh-user-card-footer d-flex justify-end">
          <v-btn
            :disabled="!formIsValid"
            rounded
            color="primary"
            type="submit"
            elevation="0"
          >
            Add user
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogInput from '@/components/forms/DialogInput.vue'
import DialogSelect from '@/components/forms/DialogSelect.vue'
import emailValidation from '@/helpers/emailValidation.js'
import { DEFAULT_LANGUAGE } from '../../helpers/constants'

const emptyForm = {
  firstName: '',
  lastName: '',
  roleId: 0,
  capacity: 0,
  isActive: true,
  phone: '',
  email: '',
  language: DEFAULT_LANGUAGE,
}

export default {
  name: 'NewBhUserDialog',
  components: {
    DialogInput,
    DialogSelect,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      newUserData: { ...emptyForm },
      isDisabledOptions: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      rules: {
        text: [v => !!v || 'Value cannot by empty'], // @todo
      },
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  computed: {
    ...mapState('dictionariesStates', ['dictionaryBhUsersRoleIds']),
    roleIdOptions() {
      return [
        {
          text: 'Admin',
          value: this.dictionaryBhUsersRoleIds.Admin,
        },
        {
          text: 'Consulant',
          value: this.dictionaryBhUsersRoleIds.Consultant,
        },
        // {
        //   text: 'Technical Support',
        //   value: this.dictionaryBhUsersRoleIds.TechnicalSupport,
        // },
      ]
    },
    formIsValid() {
      return (
        this.newUserData.firstName &&
        this.newUserData.lastName &&
        this.newUserData.roleId &&
        this.newUserData.isActive &&
        this.newUserData.phone &&
        (this.newUserData.roleId == 2 ? this.newUserData.capacity : true) &&
        this.newUserData.email &&
        this.validateEmail(this.newUserData.email)
      )
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    onInput({ name, value }) {
      this.newUserData[name] = value
    },
    clearForm() {
      this.$refs.form.reset()
      this.newUserData = { ...emptyForm }
    },
    onSubmit() {
      this.$emit('on-submit', { ...this.newUserData })
      this.clearForm()
      this.closeDialog()
    },
    validateEmail: emailValidation.validEmail,
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.new-bh-user {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
}
</style>
